import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    cart: null,
    collection: [],
    loading: false
  },
  getters: {
    cart: state => state.cart,
    collection: state => state.collection,
    loading: state => state.loading
  },
  mutations: {
    GETALL_FROM_COLLECTION(state, { collection, cart }) {
      state.collection = collection;
      state.cart = cart;
    },

    CREATE_NEW_CART(state, cart) {
      state.cart = cart;
    },

    ADD_TO_COLLECTION(state, item) {
      state.collection.push(item);
    },

    REMOVE_FROM_COLLECTION(state, cartItemId) {
      state.collection = state.collection.filter(_ => _.Id != cartItemId);
    },

    LOADING(state, value) {
      state.loading = value;
    }
  },
  actions: {
    async getUserCollection(context) {
      context.commit("LOADING", true);
      // call api to get items
      let collection = [];
      let cart = null;
      let resp = await this._vm.$http.get(`odata/LsgCart`, {
        params: {
          $top: 1,
          $filter: `Status eq ${this._vm.$const.CART_STATUS.Unsaved}`,
          $orderby: `CreatedAt desc`,
          $expand: `LsgCartItems($orderBy=DisplayOrder asc)`
        }
      });

      if (resp && resp.status == 200) {
        let carts = resp.data.value;
        if (carts && carts.length) {
          cart = carts[0];
          let list = cart.LsgCartItems;
          if (list && list.length) {
            collection = list.map(_ => {
              return {
                Id: _.Id,
                ProductId: _.ProductId,
                ImagePath: _.ImagePath,
                RootProductImage: _.RootProductImage,
                DisplayOrder: _.DisplayOrder,
                Selected: _.Selected
              };
            });
          }
        }
      }
      context.commit("GETALL_FROM_COLLECTION", { collection, cart });
      context.commit("LOADING", false);
    },

    async addToCollection(context, { product, configImage }) {
      let cart = this.state.cart;

      if (!cart || !cart.Id) {
        let respCreated = await this._vm.$http.post(`odata/LsgCart`, {
          Name: null, //"Unnamed Collection",
          Status: this._vm.$const.CART_STATUS.Unsaved
        });
        if (respCreated && respCreated.status == 201) {
          let created = respCreated.data;
          if (created) {
            cart = created;
            context.commit("CREATE_NEW_CART", cart);
          }
        }
      }

      let postedData = {
        ProductId: product.Id,
        ImagePath: product.ImagePath,
        DisplayOrder: this.state.collection
          ? this.state.collection.length + 1
          : 1,
        CartId: cart.Id,
        Selected: true
      };

      // call api to add
      let cartItemId = 0;
      let resp = await this._vm.$http.post(`odata/LsgCartItem`, postedData);
      if (resp && resp.status == 201) {
        let created = resp.data;
        if (created) {
          cartItemId = created.Id;
        }
      }

      if (cartItemId) {
        postedData.Id = cartItemId;
        context.commit("ADD_TO_COLLECTION", postedData);
      }
    },

    async removeFromCart(context, cartItemId) {
      // call api to remove
      let resp = await this._vm.$http.delete(`odata/LsgCartitem/${cartItemId}`);
      if (resp && resp.status == 204) {
        context.commit("REMOVE_FROM_COLLECTION", cartItemId);
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/collection.js